import { CartModesEP } from '@/screen/CartEducationalPlan/CartEducationalPlanScreen';
import { MODEL_PORTFOLIO_ID } from '@/store/cart/Constants';
import { ADD_FUND, UPDATE_FUND, REMOVE_FUND, CLEAR_CART, MODEL_PERCENTAGE_TOTAL, UPDATE_FUND_MODEL_PERCENTAGE, CART_STATE, MODEL_PORTFOLIO_NAME, PUNCTUAL_CONTRIBUTION_PORTFOLIO_ID, ADD_COMPETITION, ADD_COMPETITION_INFO, SET_CART_SENDING } from './Constants';
import { saveCartStateEP, saveCompetitionInfoInLS, saveCompetitionInLS } from './keepCart';

export interface ICartLineEP
{
	fund: any,
	amount: number,
	readOnly?: boolean,
	userSuscriptionId?: number,
	savingsPlanId?: number,
	source?: string,
	modelPercentage?: number
}

export interface EducationalCartState
{
	cartLines: ICartLineEP[],
	modelPercentageTotal: Number | undefined,
	current_state?: CartModesEP | string,
	modelPortfolioName: string,
	competitionId?: number,
	competitionInfo?: unknown,
	modelPortfolioId?: string,
	sending?: boolean,
	activePunctualContribution?: unknown,
}

export const INITIAL_STATE: EducationalCartState =
{
	cartLines: [],
	modelPercentageTotal: undefined,
	current_state: CartModesEP.CREATE_MODEL_PORTFOLIO,
	modelPortfolioName: "",
	modelPortfolioId: "",
	sending: false
};

export default function cartReducerEP(
	state: EducationalCartState = INITIAL_STATE,
	action: { type: string; payload?: any }
): EducationalCartState
{
	let cartLines;
	let newState;
	switch(action.type)
	{
		case ADD_FUND:
			cartLines = [...state.cartLines];
			let alreadyIncludedFund = false;
			cartLines.forEach(line =>
			{
				if(line.fund.isin === action.payload.fund.isin)
				{
					alreadyIncludedFund = true;
					if(line.readOnly === undefined || line.readOnly === null || line.readOnly === false)
					{
						line.amount += action.payload.amount || 0;
						line.modelPercentage = action.payload.modelPercentage || 0;
					}
				}
			});

			if(!alreadyIncludedFund)
			{
				const newLine: ICartLineEP =
				{
					fund: action.payload.fund,
					amount: action.payload.amount || 0,
					modelPercentage: action.payload.modelPercentage || 0,
					readOnly: action.payload.readOnly || false
				};

				if(action.payload.userSuscriptionId !== null)
				{
					newLine.userSuscriptionId = action.payload.userSuscriptionId;
				}

				if(action.payload.savingsPlanId !== null)
				{
					newLine.savingsPlanId = action.payload.savingsPlanId;
				}

				if(action.payload.source !== null)
				{
					newLine.source = action.payload.source;
				}

				cartLines.push(newLine);
			}

			newState = { ...state, cartLines };
			saveCartStateEP(newState);
			return newState;
		case ADD_COMPETITION:
			saveCompetitionInLS(newState);
			return { ...state, competitionId: action.payload };
		case ADD_COMPETITION_INFO:
			saveCompetitionInfoInLS(newState);
			return { ...state, competitionInfo: action.payload };
		case REMOVE_FUND:
			cartLines = state.cartLines.filter(line => line.fund.isin !== action.payload.isin);
			newState = { ...state, cartLines };
			saveCartStateEP(newState);
			return newState;

		case UPDATE_FUND:
			cartLines = [...state.cartLines];
			cartLines = cartLines.map(line =>
			{
				if(line.fund.isin === action.payload.fund.isin)
				{
					line.amount = action.payload.amount;
				}
				return line;
			});
			newState = { ...state, cartLines };
			saveCartStateEP(newState);
			return newState;

		case CLEAR_CART:
			newState = { ...state, cartLines: [], current_state: "CREATE_MODEL_PORTFOLIO", modelPortfolioId: "", modelPortfolioName: "" };
			saveCartStateEP(newState);
			return newState;

		case MODEL_PERCENTAGE_TOTAL:
			return { ...state, modelPercentageTotal: action.payload };

		case UPDATE_FUND_MODEL_PERCENTAGE:
			cartLines = [...state.cartLines];
			cartLines = cartLines.map(line =>
			{
				if(line.fund.isin === action.payload.fund.isin)
				{
					line.modelPercentage = action.payload.modelPercentage;
				}
				return line;
			});
			newState = { ...state, cartLines };
			saveCartStateEP(newState);
			return newState;

		case CART_STATE:
			return { ...state, current_state: action.payload };

		case MODEL_PORTFOLIO_NAME:
			return { ...state, modelPortfolioName: action.payload };
		case MODEL_PORTFOLIO_ID:
			return { ...state, modelPortfolioId: action.payload };
		case PUNCTUAL_CONTRIBUTION_PORTFOLIO_ID:
			return { ...state, activePunctualContribution: action.payload };
		case SET_CART_SENDING:
			return { ...state, sending: action.payload };
		default:
			return state;
	}
};